import api, { getSialApiHost } from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import formset from '../../versa/formset.js';
import filter, { resolveFilterLabelsToIds } from '../../versa/filter.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/integration-events.js';
import form from '../forms/integration-events.js';
import manualActionForm from '../forms/integration-events-manual-action.js';
import techhubPullForm from '../forms/integration-events-techhub-pull.js';
import * as types from '../types.js';

/** Operações exclusivas SESSP (AWS) — só com API em modo banner sessp (INTEGRATION_CENTRAL_BANNER=sessp). */
const OPERATIONS_SESSP = [
	{ hash: '#techhub-portal-toggle', label: 'Ligar / desligar integração TechHub (portal)' },
	{ hash: '#techhub-pull-company-local', label: 'Buscar faturas na IBL (empresa + cd local)' },
	{ hash: '#techhub-forced-pull', label: 'Pull forçado (TechHub) — requer mapeamento ativo' },
	{ hash: '#techhub-forced-list', label: 'Listar forçado (IBL, sem enfileirar)' },
	{ hash: '#techhub-forced-flush', label: 'Enviar status forçado (IBL)' },
];

/** Operações PRD-VPN (RVD, LLT, GF, AMIL, etc.) — Protheus / IQVIA / Close-up; sem TechHub. */
const OPERATIONS_VPN = [
	{ hash: '#integration-filter-protheus', label: 'Filtrar integração: Protheus' },
	{ hash: '#integration-filter-iqvia', label: 'Filtrar integração: IQVIA' },
	{ hash: '#integration-filter-closeup', label: 'Filtrar integração: Close-up' },
	{ hash: '#integration-filter-clear', label: 'Limpar filtro de integração' },
	{ hash: '#integration-manual-action', label: 'Registrar ação manual (contingência)' },
];

const integrationEvents = async function()
{
	let summaryBannerMode = null;
	try {
		const r = await fetch(
			`${getSialApiHost()}/integration-events/summary?hours=24&stale_minutes=12`,
			{ credentials: 'include' }
		);
		if (r.ok) {
			const j = await r.json();
			summaryBannerMode = j?.banner_mode ?? null;
		}
	} catch (_) {
		/* falha na leitura: assumir VPN (não exibir TechHub) */
	}

	const isSesspCentral = summaryBannerMode === 'sessp';
	const operations = isSesspCentral ? OPERATIONS_SESSP : OPERATIONS_VPN;

	let integration_events_crud = crud.create({
		async loadBaseData()
		{
			await Promise.all([
				api.call(api.list_users, this.queryAll()).then((data) => db.set('users', data)).catch(error => notify(error)),
				api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data)).catch(error => notify(error)),
			]);
		},
		async queryData(query)
		{
			return await api.call(api.list_integration_events, query);
		},
		async loadRecord(id)
		{
			let evId = id;
			try {
				const p = JSON.parse(id);
				if (Array.isArray(p) && p.length >= 1)
					evId = p[0];
			} catch (_) { /* id legado numérico */ }
			let _record = await api.call(api.select_integration_event, evId);
			_record.request_payload = _record.request_payload ? JSON.stringify(_record.request_payload, null, 2) : '';
			_record.response_payload = _record.response_payload ? JSON.stringify(_record.response_payload, null, 2) : '';
			return _record;
		},
		async saveRecord()
		{
		},
		editFilter()
		{
			filter.edit(this.applyFilter.bind(this), this.filter);
		},
		async applyFilter(data)
		{
			this.filter = await resolveFilterLabelsToIds(data, this.fieldspecs);
			this.loadPage(1);
		},
		/** Filtro rápido por integration_key (formato que o translate do filtro entende). */
		applyIntegrationFilter(integrationKey)
		{
			this.filter = {
				'field-0': 'integration_key',
				'operator-0': 'eq',
				'value-0': String(integrationKey || '').trim().toLowerCase(),
			};
			this.loadPage(1);
		},
		clearIntegrationFilter()
		{
			this.filter = {};
			this.loadPage(1);
		},
		registerManualAction()
		{
			let fs;
			const submit = async (data) =>
			{
				const company_id = String(data.ma_company_id || '').trim();
				const integration_key = String(data.ma_integration_key || '').trim().toLowerCase();
				const action_key = String(data.ma_action_key || '').trim();
				const date_from = String(data.ma_date_from || '').trim();
				const date_to = String(data.ma_date_to || '').trim();
				const notes = String(data.ma_notes || '').trim();

				if (!company_id || !integration_key || !action_key)
				{
					notify('Informe Empresa, Integração e Ação.', 'Atenção');
					return;
				}

				const summary = `Ação manual solicitada: ${integration_key} / ${action_key}`;
				const request_payload = {
					action_key,
					date_from: date_from || null,
					date_to: date_to || null,
					notes: notes || null,
				};

				await api.call(api.insert_integration_event, {
					company_id,
					integration_key,
					status: 'partial',
					direction: 'outbound',
					summary,
					entity_type: 'manual_action',
					entity_id: action_key,
					request_payload,
					source: 'integration-center/manual',
				});

				notify('Ação manual registrada na Central de Integrações.', 'Sucesso');
				fs.destroy();
				this.loadPage(1);
			};

			db.list('companies').then((rows) =>
			{
				fs = formset.create(manualActionForm, submit);
				fs.init();
				const dl = fs.dialog.getNode().querySelector('#manual_action_companies');
				if (dl)
				{
					dl.innerHTML = (rows || []).map((c) =>
					{
						const id = String(c.id || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
						const lab = String(c.nick || c.name || c.id || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
						return `<option value="${id}" label="${lab}"></option>`;
					}).join('');
				}
			}).catch((e) => notify(e.message || String(e), 'Falha'));
		},
		async techhubPortalToggle()
		{
			let r;
			try {
				r = await api.get_integration_events_techhub_runtime_config();
			} catch (e) {
				notify(e?.message || String(e), 'TechHub');
				return;
			}
			if (!r.ok) {
				notify((await r.text()) || `HTTP ${r.status}`, 'TechHub');
				return;
			}
			let j;
			try {
				j = await r.json();
			} catch (e) {
				notify('Resposta inválida do servidor.', 'TechHub');
				return;
			}
			const next = !j.portal_enabled;
			const msg =
				`Ambiente (servidor): ${j.env_techhub_enabled ? 'habilitado' : 'desabilitado'}.\n` +
				`Integração efetiva agora: ${j.effective_enabled ? 'ligada' : 'desligada'}.\n` +
				`Interruptor do portal: ${j.portal_enabled ? 'ligado' : 'desligado'} → passará a ${next ? 'ligado' : 'desligado'}.\n` +
				`cd_local_origem permitido: ${j.allowed_cd_local_origem}.\n\n` +
				`Confirma a alteração?`;
			ask(msg, 'TechHub — portal', async (k) => {
				if (k !== 'Y')
					return;
				let pr;
				try {
					pr = await api.put_integration_events_techhub_runtime_config(next);
				} catch (e) {
					notify(e?.message || String(e), 'TechHub');
					return;
				}
				const tx = await pr.text();
				if (!pr.ok) {
					notify(tx || `HTTP ${pr.status}`, 'Erro');
					return;
				}
				notify(next ? 'Integração TechHub habilitada no portal.' : 'Integração TechHub desabilitada no portal.', 'Sucesso');
				this.loadPage(1);
			});
		},

		/** Pull pontual: mesmo fluxo de QA — empresa (UUID ou apelido) + cd_local_origem (sem techhub_ibl_local_origins). */
		techhubPullCompanyLocal()
		{
			db.list('companies').then((rows) =>
			{
				let fs;
				const submit = async (data) =>
				{
					const company_id = String(data.tp_company_id || '').trim();
					const cdRaw = data.tp_cd_local_origem;
					if (!company_id || cdRaw == null || String(cdRaw).trim() === '')
					{
						notify('Informe empresa e cd_local_origem.', 'Atenção');
						return;
					}
					const cd_local_origem = parseInt(String(cdRaw).trim(), 10);
					if (Number.isNaN(cd_local_origem))
					{
						notify('cd_local_origem deve ser numérico.', 'Atenção');
						return;
					}
					let res;
					try
					{
						res = await api.post_integration_events_techhub_pull({
							company_id,
							cd_local_origem,
						});
					}
					catch (e)
					{
						notify(e?.message || String(e), 'Erro');
						return;
					}
					const tx = await res.text();
					if (!res.ok)
					{
						notify(tx || `HTTP ${res.status}`, 'Erro');
						return;
					}
					let j;
					try
					{
						j = JSON.parse(tx);
					}
					catch (_)
					{
						notify(tx.slice(0, 500), 'TechHub');
						return;
					}
					const r = j.result || {};
					const fetched = r.fetched != null ? r.fetched : '?';
					const enq = r.enqueued != null ? r.enqueued : '?';
					const prev = (r.preview_external_ids && r.preview_external_ids.length)
						? ` Ex.: ${r.preview_external_ids.slice(0, 6).join(', ')}${r.preview_external_ids.length > 6 ? '…' : ''}`
						: '';
					notify(`Pull IBL concluído: ${fetched} retornados, ${enq} enfileirados.${prev}`, 'TechHub');
					fs.destroy();
					this.loadPage(1);
				};

				fs = formset.create(techhubPullForm, submit);
				fs.init();
				const dl = fs.dialog.getNode().querySelector('#techhub_pull_companies');
				if (dl)
				{
					dl.innerHTML = (rows || []).map((c) =>
					{
						const id = String(c.id || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
						const lab = String(c.nick || c.name || c.id || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
						return `<option value="${id}" label="${lab}"></option>`;
					}).join('');
				}
			}).catch((e) => notify(e.message || String(e), 'Falha'));
		},

		async techhubForcedPull()
		{
			ask(
				'Executar pull forçado na IBL (buscar faturas integradas e enfileirar) para o(s) mapeamento(s) permitidos nesta fase?',
				'Pull forçado — TechHub',
				async (k) => {
					if (k !== 'Y')
						return;
					let res;
					try {
						res = await api.post_integration_events_techhub_pull({});
					} catch (e) {
						notify(e?.message || String(e), 'Erro');
						return;
					}
					const tx = await res.text();
					if (!res.ok) {
						notify(tx || `HTTP ${res.status}`, 'Erro');
						return;
					}
					notify('Pull forçado concluído. Atualize a grade.', 'TechHub');
					this.loadPage(1);
				}
			);
		},

		async techhubForcedList()
		{
			ask(
				'Listar forçado: consultar a IBL sem enfileirar itens (apenas visualização dos retornos).',
				'Listar forçado — TechHub',
				async (k) => {
					if (k !== 'Y')
						return;
					let res;
					try {
						res = await api.post_integration_events_techhub_list_integrated({});
					} catch (e) {
						notify(e?.message || String(e), 'Erro');
						return;
					}
					const tx = await res.text();
					if (!res.ok) {
						notify(tx || `HTTP ${res.status}`, 'Erro');
						return;
					}
					let data;
					try {
						data = JSON.parse(tx);
					} catch (_) {
						notify(tx.slice(0, 500), 'TechHub');
						return;
					}
					const n = data.total_fetched != null ? data.total_fetched
						: (data.result && data.result.fetched != null ? data.result.fetched : null);
					const pre = (data.result && data.result.preview_external_ids) || [];
					const extra = pre.length ? ` Ex.: ${pre.slice(0, 8).join(', ')}${pre.length > 8 ? '…' : ''}` : '';
					notify(`Listagem: ${n != null ? n : '?'} item(ns) retornados (sem enfileirar).${extra}`, 'TechHub');
				}
			);
		},

		async techhubForcedFlush()
		{
			ask(
				'Enviar status forçado: enviar à IBL as atualizações pendentes na fila de saída (outbox)?',
				'Status forçado — TechHub',
				async (k) => {
					if (k !== 'Y')
						return;
					let res;
					try {
						res = await api.post_integration_events_techhub_flush_status(200);
					} catch (e) {
						notify(e?.message || String(e), 'Erro');
						return;
					}
					const tx = await res.text();
					if (!res.ok) {
						notify(tx || `HTTP ${res.status}`, 'Erro');
						return;
					}
					notify('Envio de status concluído. Atualize a grade.', 'TechHub');
					this.loadPage(1);
				}
			);
		},
	});

	let fieldspecs = [
		{ index: 1, field: 'id', label: 'Evento', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador' },
		{ index: 2, field: 'date_time', label: 'Data/Hora', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora' },
		{ index: 3, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 4, field: 'integration_key', label: 'Integração', types: [], placeholder: '', title: 'Chave da integração' },
		{ index: 5, field: 'direction', label: 'Direção', types: [], placeholder: '', title: 'inbound / outbound' },
		{ index: 6, field: 'status', label: 'Status', types: [], placeholder: '', title: 'success / failure / partial' },
		{ index: 7, field: 'summary', label: 'Resumo', types: [], placeholder: '', title: 'Resumo' },
		{ index: 8, field: 'fetched', label: 'Integradas', types: [types.number()], placeholder: '', title: 'Inbound: só exibe se retorno > 0. Outbound: env./sep./fal. só se algum > 0.' },
		{ index: 9, field: 'entity_type', label: 'Tipo entidade', types: [], placeholder: '', title: 'Tipo da entidade' },
		{ index: 10, field: 'entity_id', label: 'ID entidade', types: [], placeholder: '', title: 'Identificador da entidade' },
		{ index: 11, field: 'error_message', label: 'Erro', types: [], placeholder: '', title: 'Mensagem de erro' },
		{ index: 12, field: 'correlation_id', label: 'Correlação', types: [], placeholder: '', title: 'UUID de correlação' },
		{ index: 13, field: 'source', label: 'Origem', types: [], placeholder: '', title: 'Origem do registro' },
		{ index: 14, field: 'recorded_by', label: 'Registrado por', types: [types.datalist()], placeholder: '', title: 'Usuário', store: 'users', labels: ['name'] },
	];

	integration_events_crud.run(
		'integration_events',
		'Eventos de integração',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		[],
	);

	router.set('#integration-filter-protheus', () => integration_events_crud.applyIntegrationFilter('protheus'));
	router.set('#integration-filter-iqvia', () => integration_events_crud.applyIntegrationFilter('iqvia'));
	router.set('#integration-filter-closeup', () => integration_events_crud.applyIntegrationFilter('closeup'));
	router.set('#integration-filter-clear', integration_events_crud.clearIntegrationFilter.bind(integration_events_crud));
	router.set('#integration-manual-action', integration_events_crud.registerManualAction.bind(integration_events_crud));

	router.set('#techhub-portal-toggle', () => integration_events_crud.techhubPortalToggle());
	router.set('#techhub-pull-company-local', () => integration_events_crud.techhubPullCompanyLocal());
	router.set('#techhub-forced-pull', () => integration_events_crud.techhubForcedPull());
	router.set('#techhub-forced-list', () => integration_events_crud.techhubForcedList());
	router.set('#techhub-forced-flush', () => integration_events_crud.techhubForcedFlush());
};

export default integrationEvents;
